export function removeTrailingSlash(input: string): string {
  // (But keep if the string is only a slash.)
  return input.replace(/^(\/)$|\/+$/g, (_, match) => match || "");
}
